import { daysBetween } from '../../../core/constants/dx';

// Helpers del dominio "pendientes" (admin-kpis.md ?view=pending), compartidos por
// Tareas y Planeación: tipos + colores, aplanado de eventos, tono de vencimiento
// (semáforo verde/amarillo/rojo) y conteos por tipo.

// Un color por tipo de tarea (para los puntos del calendario). dx1 teal, dx2 sky,
// partos ámbar — visualmente distintos entre sí.
export const PENDING_TYPES = {
    dx1:    { key: 'dx1',    label: 'Dx 1',   dateKey: 'scheduled_for', color: '#04c2a0' },
    dx2:    { key: 'dx2',    label: 'Dx 2',   dateKey: 'scheduled_for', color: '#3bb5ed' },
    births: { key: 'births', label: 'Partos', dateKey: 'expected',      color: '#f59e0b' },
};
export const PENDING_TYPE_KEYS = ['dx1', 'dx2', 'births'];

export const todayStr = () => new Date().toLocaleDateString('en-CA'); // wall-clock YYYY-MM-DD (display)

// Semáforo de vencimiento por fecha: rojo (vencida, pasada) · amarillo (≤2 días) ·
// verde (holgada). Sin fecha → verde neutro.
export function dueTone(dateStr, today = todayStr()) {
    const d = daysBetween(today, dateStr); // >0 futuro · <0 pasado
    if (d == null) return 'ok';
    if (d < 0) return 'overdue';
    if (d <= 2) return 'soon';
    return 'ok';
}

// Aplana el bloque `pending` en una lista de eventos con tipo, bucket (overdue/
// upcoming), fecha, tono de urgencia y contexto (recipient/opu/te_session/farm).
export function flattenPending(pending = {}) {
    const out = [];
    for (const key of PENDING_TYPE_KEYS) {
        const g = pending[key] || {};
        const dateKey = PENDING_TYPES[key].dateKey;
        for (const bucket of ['overdue', 'upcoming']) {
            for (const it of g[bucket]?.items || []) {
                const date = it[dateKey] || null;
                out.push({
                    id: `${key}-${bucket}-${it.diagnostic_id || it.pregnancy_id}`,
                    type: key, bucket, date, tone: dueTone(date),
                    recipient: it.recipient, opu: it.opu, te_session: it.te_session, farm: it.farm,
                    raw: it,
                });
            }
        }
    }
    return out;
}

// Conteos por tipo: { dx1: { overdue, upcoming, total }, … } + gran total.
export function pendingCounts(pending = {}) {
    const counts = {};
    let total = 0; let overdue = 0;
    for (const key of PENDING_TYPE_KEYS) {
        const g = pending[key] || {};
        const ov = g.overdue?.count || 0;
        const up = g.upcoming?.count || 0;
        counts[key] = { overdue: ov, upcoming: up, total: ov + up };
        total += ov + up; overdue += ov;
    }
    counts.total = total; counts.overdue = overdue;
    return counts;
}
